import { render, staticRenderFns } from "./AdminEmailSettings.vue?vue&type=template&id=0dd4ee83&"
import script from "./AdminEmailSettings.vue?vue&type=script&lang=ts&"
export * from "./AdminEmailSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports